import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import { selectService } from 'store/selectedService'

// Components
import SiteHeader from 'containers/SiteHeader'
import SiteMenu from 'containers/SiteMenu'
import Scene3d from 'components/Scene3d'
import ContentDrawer from 'components/ContentDrawer'
import LocationMap from 'components/LocationMap'
import ServicesNav from 'components/ServicesNav'
import EntryPoster from 'components/EntryPoster'
import ChildrenOrHidden from 'components/ChildrenOrHidden'
import DrawerTitle from 'components/DrawerTitle'

// Styles
import './PageLayout.scss'

class PageLayout extends Component {
  getSelectedServiceKey () {
    let selectedServiceKey = null
    if (this.props.selectedService) {
      selectedServiceKey = this.props.listedServices.find((service) => { return service.ID === this.props.selectedService }).key
    } else {
      selectedServiceKey = 'icosahedron'
    }
    return selectedServiceKey
  }

  isHome () {
    return this.props.content.type === 'homepage'
  }

  render () {
    return (
      <div className={`page-${this.props.content.type}`}>
        <SiteHeader />
        <Scene3d
          slide={this.props.content.type !== 'homepage' && !this.props.siteMenuVisible}
          siteMenuVisible={this.props.siteMenuVisible}
          selectedServiceKey={this.getSelectedServiceKey()}
          isHome={this.isHome()}
          selectService={this.props.selectService}
          selectedService={this.props.selectedService}
          listedServices={this.props.listedServices} />
        <TransitionGroup component={ChildrenOrHidden}>
          {
            (!this.props.siteMenuVisible && !this.isHome()) &&
            <DrawerTitle
              title={this.props.content.title}
              showBackButton={(this.props.content.type === 'singlePost')}
              showSocialLinks={(this.props.content.type === 'singlePost')} />
          }
        </TransitionGroup>
        <TransitionGroup component={ChildrenOrHidden}>
          {
            (!this.props.siteMenuVisible && !this.isHome()) &&
            <ContentDrawer
              selectedService={this.props.selectedService}
              listedServices={this.props.listedServices}
              content={this.props.content}
              siteMenuVisible={this.props.siteMenuVisible} />
          }
        </TransitionGroup>
        <TransitionGroup component={ChildrenOrHidden}>
          {
            (this.props.content.type === 'contact' && window.innerWidth >= 768) &&
            <LocationMap locations={this.props.content.locations} selectedLocation={this.props.selectedLocation} siteMenuVisible={this.props.siteMenuVisible} />
          }
        </TransitionGroup>
        <TransitionGroup component={ChildrenOrHidden}>
          {
            (this.props.content.type === 'singlePost' && this.props.content.poster && !this.props.siteMenuVisible) &&
            <EntryPoster image={this.props.content.poster} />
          }
        </TransitionGroup>
        <TransitionGroup component={ChildrenOrHidden}>
          {
            (this.props.content.type === 'service' && !this.props.siteMenuVisible) &&
            <ServicesNav services={this.props.listedServices} selectedService={this.props.selectedService} />
          }
        </TransitionGroup>
        <div className='page-layout__viewport'>
          {this.props.children}
        </div>
        {
          this.props.blockUI &&
          <div className='block-ui' />
        }
        <SiteMenu pageLayout={this} />
      </div>
    )
  }
}

PageLayout.propTypes = {
  children: PropTypes.node,
  content: PropTypes.object,
  selectedLocation: PropTypes.number,
  selectedService: PropTypes.number,
  selectService: PropTypes.func,
  listedServices: PropTypes.array,
  siteMenuVisible: PropTypes.bool,
  blockUI: PropTypes.bool
}

const mapStateToProps = (state) => ({
  location: location,
  content: state.content,
  selectedLocation: state.selectedLocation,
  selectedService: state.selectedService,
  listedServices: state.listedServices,
  siteMenuVisible: state.siteMenuVisible,
  blockUI: state.blockUI
})

const mapDispatchToProps = {
  selectService: (serviceID) => selectService(serviceID)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js